import "./App.css";
import Header from "./components/Header";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Services from "./pages/Services";
import Products from "./pages/Products";
import Footer from "./components/Footer";
import { ToastContainer } from "react-toastify";
import ProductDetail from "./pages/ProductDetail";
import ServiceDetail from "./pages/ServiceDetail";
import CrispChat from "./components/CrispChat";
import "./fonts";
import useStore from "./context/store";

function App() {
  const data = useStore((state) => state);

  return (
    <div className="App">
      <Router>
        <Header
          data={data.store.commonData.navigation.menuItems}
          logo={data.store.commonData.companyDetails.logoImageUrl}
        />
        <Routes>
          <Route
            path={data.store.commonData.navigation.menuItems[0].link}
            element={<Home />}
          />
          <Route
            path={data.store.commonData.navigation.menuItems[1].link}
            element={<About />}
          />
          <Route
            path={data.store.commonData.navigation.menuItems[2].link}
            element={<Services />}
          />
          <Route
            path={data.store.commonData.navigation.menuItems[3].link}
            element={<Products />}
          />
          <Route
            path={data.store.commonData.navigation.menuItems[4].link}
            element={<Contact />}
          />
          <Route
            path={`${data.store.commonData.navigation.menuItems[3].link}/:productId`}
            element={<ProductDetail />}
          />
          <Route
            path={`${data.store.commonData.navigation.menuItems[2].link}/:serviceId`}
            element={<ServiceDetail />}
          />
        </Routes>
        <CrispChat />
        <ToastContainer />
        <Footer data={data.store.commonData} />
      </Router>
    </div>
  );
}

export default App;
